module.exports = __webpack_public_path__ + "img/icon_st03.40b386df.png";